import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const UserIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon className='user-icon' {...props}>
            <svg version="1.1" id="Capa_1" x="0px" y="0px"
                 viewBox="-49 141 512 512">
                <path d="M461.702,579.722c-2.251-10.813-12.84-17.754-23.657-15.503
                    c-10.814,2.251-17.755,12.843-15.503,23.656c1.297,6.229-0.248,12.613-4.236,17.519c-2.31,2.841-7.461,7.606-15.999,7.606H11.693
                    c-8.538,0-13.689-4.766-15.999-7.606c-3.989-4.905-5.533-11.29-4.236-17.519c20.756-99.695,108.691-172.521,210.24-174.977
                    c1.759,0.068,3.526,0.102,5.302,0.102c1.782,0,3.556-0.035,5.322-0.103c71.532,1.716,137.648,37.947,177.687,97.66
                    c6.151,9.175,18.574,11.625,27.75,5.474c9.174-6.151,11.625-18.575,5.473-27.749c-32.817-48.944-80.47-84.534-134.804-102.417
                    C321.538,361.036,343,321.477,343,277c0-74.99-61.009-136-136-136S71,202.01,71,277c0,44.504,21.488,84.084,54.633,108.911
                    c-30.368,9.998-58.863,25.555-83.803,46.069c-45.732,37.617-77.529,90.086-89.532,147.742c-3.762,18.067,0.745,36.623,12.363,50.909
                    C-23.778,644.847-6.635,653,11.693,653h390.613c18.329,0,35.472-8.153,47.032-22.369
                    C460.958,616.345,465.464,597.789,461.702,579.722z M111,277c0-52.935,43.065-96,96-96s96,43.065,96,96
                    c0,51.305-40.455,93.339-91.141,95.878c-1.617-0.03-3.237-0.045-4.859-0.045c-1.614,0-3.228,0.016-4.84,0.046
                    C151.465,370.35,111,328.312,111,277z"/>
            </svg>
        </SvgIcon>
    )
};

export default UserIcon;